var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestmentsStocks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-5026.000000, -1708.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investments/Stocks",
    transform: "translate(5026.000000, 1708.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,15.0000552 L32,28.0000103 C32,29.6570046 30.6579706,31 28.9999344,31 L28.9999344,31 L9.99951874,31 L9.99951874,20.0000379 L18.9997156,20.0000379 C21.7567759,20.0000379 23.999825,17.7560457 23.999825,15.0000552 L23.999825,15.0000552 L32,15.0000552 Z M25.7208626,19.4270399 L23.817821,19.4280399 L23.817821,25.1690201 L22.077783,23.4290261 C21.3337667,22.6860287 20.1287403,22.6860287 19.384724,23.4290261 L19.384724,23.4290261 L24.7698418,28.8130075 L30.1539596,23.4290261 C29.4109434,22.6860287 28.204917,22.6860287 27.4609007,23.4290261 L27.4609007,23.4290261 L25.7208626,25.1690201 L25.7208626,19.4270399 Z M22.0004813,2 L22.0004813,14.9999552 C22.0004813,16.6569495 20.6574519,17.9999448 19.0004156,17.9999448 L19.0004156,17.9999448 L0,17.9999448 L0,4.99998966 C0,3.34299537 1.34302938,2 3.00006563,2 L3.00006563,2 L22.0004813,2 Z M14.3843147,6.47598457 L9.00019688,11.859966 C9.74321313,12.6029634 10.9482395,12.6029634 11.6922558,11.859966 L11.6922558,11.859966 L13.4322938,10.119972 L13.4322938,15.8609522 L15.3363355,15.8609522 L15.3363355,10.119972 L17.0763735,11.859966 C17.8193898,12.6029634 19.0244162,12.6029634 19.7674324,11.859966 L19.7674324,11.859966 L14.3843147,6.47598457 Z",
    id: 12
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentsStocks);
export default __webpack_public_path__ + "static/media/investments-stocks.dab9d72d.svg";
export { ForwardRef as ReactComponent };